(ns rothko.theme.manatee.audio.mini-player
  (:refer-clojure :exclude [rem])
  (:require [garden.units :refer [rem]]))

(def main
  {:align-left
   {:justify-content :flex-start
    :margin 0}

   :align-center
   {:justify-content :center
    :margin (rem 1)}})
